module.exports = __webpack_public_path__ + "static/media/trygg.8d8bdf2f.mp3";